export default "__VITE_ASSET__BHM1OwTR__"